<template>
  <div>
    <b-tabs v-model="tabIndex" card>
      <b-tab title="Care Plans">
        <call-table />
      </b-tab>
      <b-tab title="Manage">
        <call-form />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import CallForm from "./callForm";
import CallTable from "./callTable";
import { mapGetters } from "vuex";
export default {
  name: "Display_CallLog",
  components: {
    CallForm,
    CallTable
  },
  props: {
    resource: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      user: "user/user"
    }),
    settings() {
      if (this.resource && this.resource.data && this.resource.data.settings)
        return this.resource.data.settings; //TDO move to MIXIN
      return null;
    }
  },
  methods: {
    handleData() {},
    handleChange(changeMade) {
      //console.log(changeMade);
    }
  },
  data() {
    return {
      tabIndex: 0
    };
  }
};
</script>

<style lang="scss" scoped></style>
